import { Messages } from "../../lib/locale";

export const Swedish: Messages = {
  name: "Svenska",
  helpTitle: "Hur man spelar",
  help1: `Din uppgift är att ta reda på vilket land som är gömt i spelet. För att göra detta måste du ange namnen på slumpmässiga länder. Skriv landet i inmatningsrutan och tryck på Enter. Detta land kommer att visas på kartan och ändra färg beroende på hur nära det är det dolda landet. Ju mörkare färg, desto närmare svaret är du!`,
  help2: `Titta på spelexemplet. Låt oss säga att landet Japan är gömt i spelet. Då kommer dessa länder att målas i sådana färger.`,
  help3: `En gång om dagen finns ett nytt gömt land tillgängligt. Eller växla till fritt läge i inställningarna och spela obegränsat.`,
  France: "Frankrike",
  Nepal: "Nepal",
  Mongolia: "Mongoliet",
  "South Korea": "Sydkorea",
  Aux1: `<b>["Klicka", "Tryck"]</b> på jordklotet för att börja!`,
  Loading: "Vänta på det...",
  GameTitle: "Spel",
  Game1: "Ange landets namn här",
  Game2: "Gissa",
  Game3: "Skriv in ett slumpmässigt landsnamn och tryck på Enter för att starta",
  Game4: `Snurra, <span>["klicka", "peka"]</span> och zooma jorden runt för att hitta nästa land att gissa`,
  Game5: "Vi känner inte till det här landet",
  Game6: "Detta land har redan angetts",
  Game7: "Det dolda landet var {answer}!",
  Game8: "Närmaste gräns",
  StatsTitle: "Statistik",
  Stats1: "Sista vinsten",
  Stats2: "Dagens gissningar",
  Stats3: "Spel vunna",
  Stats4: "Nuvarande rad",
  Stats5: "Max rad",
  Stats6: "Genomsnittliga gissningar",
  Stats7: "Genomsnittliga gissningar",
  Stats8: "Återställa",
  Stats9: "Dela med sig",
  Stats10: "Är du säker på att du vill återställa din poäng?",
  Stats11: "Statistik raderade.",
  Stats12: "Kopierat till urklipp!",
  SettingsTitle: "inställningar",
  Settings1: "Dagens tema",
  Settings2: "Natt tema",
  Settings3: "Färgblindläge på",
  Settings4: "Färgblindläge Av",
  Settings5: "Länder",
  Settings7: "Språk",
  Settings9: "Fritt läge",
  Answer: "Svar",
  Closest: "Närmast",
  Guessed: "Gissade",
  PracticeMode: "Du är i fritt läge.",
  PracticeExit: "Avsluta fritt läge",
  PracticeNew: "Nytt gratis spel",
  PlayAgain: "Spela igen",
  SortBy: "Sortera efter:",
  SortByGuesses: "gissningsordning",
  SortByDistance: "avstånd",
  Clipboard: "🌍🌍🌍\nJag gissade det dolda landet i dagens Globle på {X} gissningar\nKan du göra det bättre?\nhttps://globlegame.org/\n#globle\n🌍🌍🌍",
  Victory: "Seger",
  Guesses: "Gissningar",
};